import { createRouter, createWebHistory } from "vue-router"

import Backdoor from "@/components/Backdoor.vue"
import Dashboard from "@/components/Dashboard.vue"
import Item from "@/components/Item.vue"
import ItemEditColors from "@/components/ItemEditColors.vue"
import ItemEditMedias from "@/components/ItemEditMedias.vue"
import ItemEditPrices from "@/components/ItemEditPrices.vue"
import ItemEditSpecs from "@/components/ItemEditSpecs.vue"
import ItemNew from "@/components/ItemNew.vue"
import Items from "@/components/Items.vue"
import LogIn from "@/components/LogIn.vue"
import Order from "@/components/Order.vue"
import Orders from "@/components/Orders.vue"
import Payout from "@/components/Payout.vue"
import Payouts from "@/components/Payouts.vue"
import Settings from "@/components/Settings.vue"
import SettingsEditNotfication from "@/components/SettingsEditNotfication.vue"
import ShipOutCompleteOrder from "@/components/ShipOutCompleteOrder.vue"
import ShipOutPrintMark from "@/components/ShipOutPrintMark.vue"
import ShipOutSetUpMark from "@/components/ShipOutSetUpMark.vue"
import ShipOuts from "@/components/ShipOuts.vue"
import StockInquiries from "@/components/StockInquiries.vue"
import StockInquiry from "@/components/StockInquiry.vue"
import SwatchStockEdit from "@/components/SwatchStockEdit.vue"
import SwatchStocks from "@/components/SwatchStocks.vue"
import store from "@/plugins/store"

const routesNoAuth = [
  { path: "/log_in", component: LogIn },
  { path: "/backdoor", component: Backdoor },
]

const routesAuth = [
  { path: "/", component: Dashboard },
  { path: "/items", component: Items },
  { path: "/items/new", component: ItemNew },
  { path: "/items/:id", component: Item },
  { path: "/items/:id/edit_medias", component: ItemEditMedias },
  { path: "/items/:id/edit_specs", component: ItemEditSpecs },
  { path: "/items/:id/edit_prices", component: ItemEditPrices },
  { path: "/items/:id/edit_colors", component: ItemEditColors },
  { path: "/orders", component: Orders },
  { path: "/orders/:id", component: Order },
  { path: "/ship_outs", component: ShipOuts },
  { path: "/ship_outs/:pur_product_id/set_up_mark", component: ShipOutSetUpMark },
  { path: "/ship_outs/:pur_product_id/print_mark", component: ShipOutPrintMark },
  { path: "/ship_outs/:order_id/complete_order", component: ShipOutCompleteOrder },
  { path: "/payouts", component: Payouts },
  { path: "/payouts/:id", component: Payout },
  { path: "/swatch_stocks", component: SwatchStocks },
  { path: "/swatch_stocks/:id/edit", component: SwatchStockEdit },
  { path: "/stock_inquiries", component: StockInquiries },
  { path: "/stock_inquiries/:id", component: StockInquiry },
  { path: "/settings", component: Settings },
  { path: "/settings/edit_notification", component: SettingsEditNotfication },
].map((route) => ({
  ...route,
  meta: { requiresAuth: true },
}))

const router = createRouter({
  history: createWebHistory(),
  routes: [...routesNoAuth, ...routesAuth, { path: "/:pathMatch(.*)*", redirect: "/" }],
})

router.beforeEach(async (to, _from, next) => {
  const needsAuth = to.meta.requiresAuth
  const hasToken = Boolean(store.state.token?.trim())

  if (needsAuth && !hasToken) {
    // redirect to log_in and preserve the original page
    next({
      path: "/log_in",
      query: { redirect: to.fullPath },
    })
    return
  }

  // A token can outlive the partner record. main.ts swallows a failed
  // loadPartner at boot and mounts the app anyway, and the action itself
  // returns null when /partners/me fails, so the app can run authenticated
  // with `partner` still null. Every page that reads it then degrades
  // silently -- Order.vue hides its cards behind v-if="partner" and crashed
  // where the delivery method is derived (PARTNER-FRONTEND-XV).
  // Fill it once more here, then fall back to log_in. No `force`, so an
  // in-memory or localStorage hit costs no request.
  if (needsAuth && !store.state.partner) {
    const partner = await store.dispatch("loadPartner")

    if (!partner) {
      next({
        path: "/log_in",
        query: { redirect: to.fullPath },
      })
      return
    }
  }

  next()
})

export default router
